import React, { useEffect, useRef } from "react";
import SunEditor from "suneditor-react";
// import "suneditor/dist/css/suneditor.min.css";
// import "suneditor/src/assets/css/suneditor.css";
import { en } from "suneditor/src/lang";
import plugins from "suneditor/src/plugins";
// import CodeMirror from "codemirror";

import katex from "katex";

const customCSS = `
  body { font-family: Georgia, serif; font-size: 16px; line-height: 1.6; }
  h1 { color: darkred; }
`;

const defaultOptions = {
  previewTemplate: `
                <div style="width:auto; max-width:1136px; min-height:400px; margin:auto;">
                {{contents}}
                </div>
            `,
  buttonList: [
    // default
    ['undo', 'redo'],
    ['font', 'fontSize', 'formatBlock'],
    ['paragraphStyle', 'blockquote'],
    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
    ['fontColor', 'hiliteColor', 'textStyle'],
    ['removeFormat'],
    ['outdent', 'indent'],
    ['align', 'horizontalRule', 'list', 'lineHeight'],
    ['table', 'link', 'image', 'video'],
    ['fullScreen', 'showBlocks', 'codeView'],
    ['preview'],
    ['save'],
    // responsive
    ['%1161', [
      ['undo', 'redo'],
      [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
      ['fontColor', 'hiliteColor', 'textStyle'],
      ['removeFormat'],
      ['outdent', 'indent'],
      ['align', 'horizontalRule', 'list', 'lineHeight'],
      // ['-right', 'save'],
      ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
      ['-right', ':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
    ]],
    ['%893', [
      ['undo', 'redo'],
      [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
      ['bold', 'underline', 'italic', 'strike'],
      [':t-Fonts-default.more_text', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle'],
      ['removeFormat'],
      ['outdent', 'indent'],
      ['align', 'horizontalRule', 'list', 'lineHeight'],
      // ['-right', 'save'],
      ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
      ['-right', ':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
    ]],
    ['%855', [
      ['undo', 'redo'],
      [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
      [':t-Fonts-default.more_text', 'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle'],
      ['removeFormat'],
      ['outdent', 'indent'],
      ['align', 'horizontalRule', 'list', 'lineHeight'],
      [':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
      // ['-right', 'save'],
      ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
    ]],
    ['%563', [
      ['undo', 'redo'],
      [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
      [':t-Fonts-default.more_text', 'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle'],
      ['removeFormat'],
      ['outdent', 'indent'],
      [':e-List&Line-default.more_horizontal', 'align', 'horizontalRule', 'list', 'lineHeight'],
      [':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
      // ['-right', 'save'],
      ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
    ]],
    ['%458', [
      ['undo', 'redo'],
      [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
      [':t-Fonts-default.more_text', 'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle', 'removeFormat'],
      [':e-List&Line-default.more_horizontal', 'outdent', 'indent', 'align', 'horizontalRule', 'list', 'lineHeight'],
      [':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
      // ['-right', 'save'],
      ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
    ]]
  ],
  attributesWhitelist: {
    all: "style|data-.+",
    input: "checked|name",
    '???': '*' // "*" === all attributes
  },
  defaultStyle: "font-family: Arial; font-size: 14px;",
  // height: "auto",
  // minHeight: "200px",
  // maxHeight: "600px",
  plugins: plugins,
  lang: en,
  fullPage: true,
  // codeMirror: CodeMirror,
  stickyToolbar: 0,
  katex: katex,
  width: '100%',
  height: 'auto',
  minHeight: '200px',
  
  // imageUploadUrl: `url`,
  imageMultipleFile: true,
  strictMode: false,
  iframe: true,
  iframeCSSFileName: [
    // SunEditor’s own CSS from CDN
      'https://cdn.jsdelivr.net/npm/suneditor/dist/css/suneditor.min.css',
      // ".+.css"
      // "suneditor/dist/css/suneditor.min.css",
      // "suneditor/src/assets/css/suneditor.css"
      // '/suneditor.min.css'

  ],
  iframeAttributes: {
    scrolling: 'yes' // or 'no' or 'auto'
  }
};

const SunEditorComponent = ({ value, onChange, options = {}, justUpdatedValue }) => {
  const editorRef = useRef(null);
  console.log("SunEditor CSS Path:", process.env.PUBLIC_URL + '/suneditor.min.css');

  useEffect(() => {
    // if (editorRef.current && value !== editorRef.current.getContents()) {
    //   editorRef.current.setContents(value || "");
    // }
    if (editorRef.current) {
    try {
      if (value !== editorRef.current.getContents()) {
        editorRef.current.setContents(value || "");
      }
    } catch (e) {
      // iframe not ready yet
    }
  }
  }, []);

  useEffect(() => {
    console.log("justUpdatedValue changed:", justUpdatedValue, typeof justUpdatedValue);
    if (editorRef.current && typeof justUpdatedValue === 'string') {
      editorRef.current.setContents(justUpdatedValue);
    }
  }, [justUpdatedValue]);

  return (
    <div className="sun-editor-container">
      <style jsx>{`
        .se-btn-module button,
        .se-btn-module .se-btn,
        .se-btn-module .se-tooltip-inner {
          height: 20px !important;
          width: 20px !important;
          color: #3a3b3bff;
        }
        .se-btn-module .se-tooltip-inner {
          padding: 2px !important;
        }
        .se-tooltip-inner svg {
          stroke-width: 0.9px !important;
          stroke: #4b5563 !important;
          fill: none !important;
        }
        .se-tooltip-inner svg[data-color-fill="true"] {
          fill: #4b5563 !important;
          stroke: none !important;
        }
        .sun-editor .se-btn:hover .se-tooltip-inner svg {
          stroke: #3a3b3bff !important;
        }
        
      `}</style>
      <SunEditor
        getSunEditorInstance={(editor) => (editorRef.current = editor)}
        setOptions={{ ...defaultOptions, ...options }}
        onChange={onChange}
      />
    </div>
  );
};

export default SunEditorComponent;